export const CARSTATUSCONDITION_REQUEST = "CARSTATUSCONDITION_REQUEST";
export const CARSTATUSCONDITION_SUCCESS = "CARSTATUSCONDITION_SUCCESS";
export const CARSTATUSCONDITION_FAIL = "CARSTATUSCONDITION_FAIL";
